import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  // min-h-11 / min-w-11 — цель нажатия не меньше 44 × 44 pt
  // (ROADMAP, сквозные требования: мобильный интерфейс).
  'inline-flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-lg text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-accent text-accent-fg hover:opacity-90',
        outline: 'border border-line bg-surface text-ink hover:border-accent',
        ghost: 'text-ink-2 hover:bg-surface-2',
      },
      size: {
        default: 'px-4 py-2',
        sm: 'px-3 py-1.5 text-[13px]',
        icon: 'w-11 px-0',
      },
    },
    defaultVariants: { variant: 'outline', size: 'default' },
  },
);
